<template>
  <div class="p-5">
    <a-tabs :active-key="activeKey" @change="TabChange" >
      <a-tab-pane key="1" >
        <span slot="tab" class=" text-2xl">
          <a-icon type="history" />
          暫停營運
        </span>
      </a-tab-pane>
      <a-tab-pane key="2">
        <span slot="tab" class=" text-2xl">
          <a-icon type="retweet" />
          恢復營運
        </span>
      </a-tab-pane>
    </a-tabs>

    <div class="overflow-hidden">
      <transition name="slide-fade" mode="out-in">
        <div v-if="activeKey === '1'" key="1" class=" w-2/4 min-w-[740px] m-auto px-3 py-5 rounded-3xl" style="background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%)">
          <div class="flex flex-row justify-between gap-4">
            <a-date-picker v-model="startDate" class="flex-grow flex-shrink-0" size="large" show-time placeholder="暫停營運起始時間" @change="StartDateChange" />
            <div class="flex items-center">-</div>
            <a-date-picker v-model="endDate" class="flex-grow flex-shrink-0" size="large" showToday show-time placeholder="暫停營運結尾時間" @change="EndDateChange" />

            <div>
              <a-select @change="RebootType" size="large" show-search placeholder="恢復營運是否重開機" class="w-[200px]">
                <a-select-option v-for="item of optionArr" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>

          <div class="mt-5 flex gap-8">
            <a-select
              v-model="selectedDeviceArr"
              :maxTagCount="20"
              :maxTagTextLength="6"
              allowClear
              size="large"
              class="w-full"
              mode="multiple"
              placeholder="請選擇欲暫停營運機台"
              :filter-option="filterOption"
            >
              <a-select-option v-for="item of deviceList" :key="item.device_mac" :value="item.device_mac">
                {{ item.device_name }}
              </a-select-option>
            </a-select>
            <a-button @click="MqttSuspend()" type="primary" icon="search"> 發送暫停營運 </a-button>
          </div>
        </div>
        <div v-else key="2" class=" w-2/4 min-w-[740px] m-auto px-3 py-5 rounded-3xl" style="background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%)">
          <div class="mt-5 flex gap-8">
            <a-select
              v-model="selectedResumeDeviceArr"
              :maxTagCount="20"
              :maxTagTextLength="6"
              allowClear
              size="large"
              class="w-full"
              mode="multiple"
              placeholder="請選擇欲恢復營運機台"
              :filter-option="filterOption"
            >
              <a-select-option v-for="item of deviceList" :key="item.device_mac" :value="item.device_mac">
                {{ item.device_name }}
              </a-select-option>
            </a-select>
            <a-button @click="MqttResume()" type="primary" icon="search"> 發送恢復營運 </a-button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { filterOption } from '@/utils/search'

export default {
  name: 'Suspend',

  data () {
    return {
      baseURL: this.GLOBAL.baseURL,
      basePort: this.GLOBAL.basePort,
      suspendTime: null,
      resumeTime: null,
      rebootAfterResume: null,
      startDate: null,
      endDate: null,
      selectedDeviceArr: [],
      selectedResumeDeviceArr: [],
      activeKey: '1',
      optionArr: [
        {
          name: '保持開機',
          value: 'false'
        },
        {
          name: '重新開機',
          value: 'true'
        }
      ],
      cc: {
        suspendTime: 1720141200,
        resumeTime: 1720155600,
        rebootAfterResume: false,
        selectedDeviceArr: ['0007329eec01', '000732b29065', '000732b2807d', '000732ac46ab']
      }
    }
  },
  computed: {
    deviceList: {
      get () {
        return this.$store.state.deviceList
      },
      set () {}
    },
    mqttClient: {
      get () {
        return this.$store.state.mqttClient
      },
      set () {}
    }
  },
  mounted () {},

  methods: {
    moment,
    filterOption,
    TabChange (key) {
      console.log(key)
      this.activeKey = key
      this.selectedDeviceArr = []
      this.selectedResumeDeviceArr = []
    },
    async MqttSuspend () {
      if (this.rebootAfterResume === null || !this.suspendTime || !this.resumeTime || this.selectedDeviceArr.length < 1) {
        this.$message.error('有選項未選擇')
        return false
      }
      try {
        const inf = JSON.stringify({
          suspendTime: this.suspendTime,
          resumeTime: this.resumeTime,
          rebootAfterResume: this.rebootAfterResume
        })
        const mqttPromises = this.selectedDeviceArr.map((mac) => {
          return new Promise((resolve) => {
            // eslint-disable-next-line no-undef
            const message = new Paho.MQTT.Message(inf)
            message.destinationName = `command/${mac}/suspendOperation`
            this.mqttClient.send(message)
            resolve()
          })
        })
        // 使用 Promise.all 等待所有的異步操作完成
        await Promise.all(mqttPromises)
        this.$message.success('通知更新完成')
      } catch (error) {
        console.error(error)
      }
    },
    async MqttResume () {
      if (this.selectedResumeDeviceArr.length < 1) {
        this.$message.error('未選擇機台')
        return false
      }
      try {
        const inf = JSON.stringify({})
        const mqttPromises = this.selectedResumeDeviceArr.map((mac) => {
          return new Promise((resolve) => {
            // eslint-disable-next-line no-undef
            const message = new Paho.MQTT.Message(inf)
            message.destinationName = `command/${mac}/resumeOperation`
            this.mqttClient.send(message)
            resolve()
          })
        })
        // 使用 Promise.all 等待所有的異步操作完成
        await Promise.all(mqttPromises)
        this.$message.success('通知更新完成')
      } catch (error) {
        console.error(error)
      }
    },
    RebootType (value) {
      console.log(`selected ${value}`)
      if (value === 'true') {
        this.rebootAfterResume = true
      } else {
        this.rebootAfterResume = false
      }
    },
    EndDateChange (value, dateString) {
      console.log('Selected Time: ', value)
      console.log('Formatted Selected Time: ', dateString)
      this.endDate = dateString
      const formattedTimeString = dateString.replace(' ', 'T')
      // const gmtDate = new Date(formattedTimeString + 'Z')
      const gmtDate = new Date(formattedTimeString)
      const gmtTimestamp = gmtDate.getTime()
      const gmtTimestampInSeconds = Math.floor(gmtTimestamp / 1000)
      this.resumeTime = gmtTimestampInSeconds
    },
    StartDateChange (value, dateString) {
      console.log('Selected Time: ', value)
      console.log('Formatted Selected Time: ', dateString)
      this.startDate = dateString
      // 將空格替換為'T'
      const formattedTimeString = dateString.replace(' ', 'T')
      // 創建一個Date對象
      const localDate = new Date(formattedTimeString)
      // 獲取當前時間的本地時區偏移量（分鐘）
      //   const timezoneOffsetInMinutes = localDate.getTimezoneOffset()
      //   console.log(timezoneOffsetInMinutes)
      // 計算GMT時間戳（毫秒數）
      const gmtTimestamp = localDate.getTime()
      // 將毫秒數轉換為秒數
      const gmtTimestampInSeconds = Math.floor(gmtTimestamp / 1000)
      console.log(gmtTimestampInSeconds)
      this.suspendTime = gmtTimestampInSeconds
    }
  }
}
</script>

<style lang="css" scoped>
.ant-btn {
  font-size: 20px;
  /* padding: -10px 15px -25px 15px; */
  height: 38px;
  padding-bottom: 5px;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter, .slide-fade-leave-to /* .slide-fade-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateX(50px);
}
</style>
